export default "__VITE_ASSET__ByAFsKZg__"